'use client';
import { useAccount } from '@/hooks/useAccount';
import React from 'react';
import { SubscriptionTier } from '@/actions/dtos/subscription';
import TenderDataAccessNotice from './TenderDataAccessNotice';

type TenderAccessWrapperProps = {
  children: React.ReactNode;
  isActive: boolean;
};

const TenderAccessWrapper = ({ children, isActive }: TenderAccessWrapperProps) => {
  const { currentTier } = useAccount();

  if (currentTier === SubscriptionTier.BASIC && !isActive) {
    return <TenderDataAccessNotice />;
  }

  return <>{children}</>;
};

export default TenderAccessWrapper;
